var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('official-factor-filter',{attrs:{"actionAllUsers":_vm.exportExcelAllUsers,"action":_vm.filterAction}}),(_vm.status === 'success')?_c('user-reports-official-factor',{attrs:{"officialFactor":_vm.officialFactor,"query":_vm.query}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }